module.exports = require('./cartocolor');
